import React, { useEffect, useMemo, useState } from 'react';
import DataTable from 'react-data-table-component';
import { SiLibreofficewriter } from 'react-icons/si';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { useToast } from "../../../hooks/useToast";
import { InfluencerImg } from '../../../static/constant/imgConstants';
import { getUserInfo, getUserInfoReset } from "../../../store/authStore/actions/authActions/getUserInfoActions";
import {
    sendOtpForMobileVerified,
    sendOtpForMobileVerifiedReset
} from "../../../store/authStore/actions/authActions/sendOtpForMobileVerifiedAction";
import {
    verifyMobileOtp,
    verifyMobileOtpReset
} from "../../../store/authStore/actions/authActions/verifyMobileOtpActions";
import {
    updateUserInfo,
    updateUserInfoReset
} from "../../../store/authStore/actions/authActions/updateUserInfoActions";
import { getCampaignListWithFilterDashBoard } from '../../../store/brandDashboardStore/actions/getCampaignListWithFilterDashBoardActions';
import { getDashboardData } from '../../../store/brandDashboardStore/actions/getDashboardDataActions';
import { getMyBrandBusinessDetail } from '../../../store/BusinessStore/actions/BrandBusinessActions/getMyBrandBusinessDetailActions';
import { getStateByCountry } from '../../../store/campaignStore/actions/CampaignMasterActions/getStateByCountryActions';
import { getAllCountry } from '../../../store/publicStore/actions/publicActions/getAllCountryActions';
import DropdownWithSearch from "../../common/DropdownWithSearch/DropdownWithSearch";
import Footer from '../../common/Footer/Footer';
import Popup from '../../popups/Popup/Popup';
import BrandFilterBar from '../../common/BrandFilterBar/BrandFilterBar';

const BrandDashboardV2 = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const Toast = useToast();


    const [country, setCountry] = useState();
    const [selectedState, setSelectedState] = useState();
    const [selectedBrandId, setSelectedBrandId] = useState("");

    const [isPopupOpen, setPopupOpen] = useState(false);



    const getUserInfoReducerData = useSelector(state => state.getUserInfoReducer.data);
    const getAllCountryReducerData = useSelector(state => state.getAllCountryReducer.data);
    const getAllCountryReducerStatus = useSelector(state => state.getAllCountryReducer.status);
    const getStateByCountryReducerData = useSelector(state => state.getStateByCountryReducer?.data);
    const getDashboardDataReducerData = useSelector(state => state.getDashboardDataReducer?.data);
    const getCampaignListWithFilterDashBoardReducerData = useSelector(state => state.getCampaignListWithFilterDashBoardReducer?.data);
    const getAllCountryReducer = useSelector(state => state.getAllCountryReducer);
    const sendOtpForMobileVerifiedReducer = useSelector(state => state.sendOtpForMobileVerifiedReducer);
    const utilReducers = useSelector(state => state.utilReducers)
    const getUserInfoReducer = useSelector(state => state.getUserInfoReducer);
    const verifyMobileOtpReducer = useSelector(state => state.verifyMobileOtpReducer)
    const updateUserInfoReducer = useSelector(state => state.updateUserInfoReducer)

    const [errors, setErrors] = useState({});
    const [countryCode, setCountryCode] = useState(null); // State for country code and phone number
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [gender, setGender] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [otpMobile, setOtpMobile] = useState(new Array(4).fill(''));
    const [message, setMessage] = useState('');
    const [otpShow, setOtpShow] = useState(false);
    const [isPhoneVerifyPopupOpen, setIsPhoneVerifyPopupOpen] = useState(false);
    const [platformFilter, setPlatformFilter] = useState("ALL");
    const [brandId, setBrandId] = useState("");
    const [referredBy, setReferredBy] = useState('');

    const userInfo = getUserInfoReducer?.data;
    const isAppleUser = userInfo?.firstName?.toLowerCase() === 'apple' && userInfo?.lastName?.toLowerCase() === 'user';


    const customTableStyles = {
        table: {
            style: {
                position: 'relative',
            },
        },
        headRow: {
            style: {
                backgroundColor: '#F1F4F9',
                minHeight: '52px',
                fontWeight: 700,
                borderRadius: '0.4rem',
                borderBottom: 'none',
                // position: 'fixed',
                top: 0,
            },
            denseStyle: {
                minHeight: '32px',
            },
        },
        rows: {
            style: {
                fontSize: '1.4rem',  // Increased text size for rows
                fontWeight: 600,
                color: '#000000',
                borderBottom: '1px solid #EDEFF1',
                minHeight: '70px',
            },
            denseStyle: {
                minHeight: '40px',
            },
        },
        headCells: {
            style: {
                padding: '1rem',
                fontSize: '1.6rem',
                textAlign: 'left',
            },
        },
        cells: {
            style: {
                padding: '1.5rem',
            },
        },
    };

    const columns = [
        {
            name: 'Total Budget',
            selector: row => getDashboardDataReducerData?.influencerViewsProgress?.totalBudget + " $",
            sortable: true,
            style: {
                width: '10rem',  // Set a smaller width for this column
            },
        },
        {
            name: 'Influencer',
            selector: row => row.influencerName,
            sortable: true,
            style: {
                width: '10rem',  // Adjust the width as needed
            },
        },
        {
            name: 'View Capacity',
            selector: row => row.viewCapacity,
            style: {
                width: '10rem',  // Set a smaller width for this column
            },
        },
        {
            name: 'Progress (%)',
            selector: row => row.progress + "%",
            style: {
                width: '10rem',  // Adjust the width for consistency
            },
        },
        {
            name: 'Remaining Views',
            selector: row => (row.remainingView),
            style: {
                width: '10rem',
            },
        },
    ];

    const columnsMaxBudget = [
        {
            name: 'Total Budget',
            selector: row => getDashboardDataReducerData?.influencerViewsProgress?.totalBudget + " $",
            sortable: true,
            style: {
                width: '10rem',  // Set a smaller width for this column
            },
        },
        {
            name: 'Influencer',
            selector: row => row.influencerName,
            sortable: true,
            style: {
                width: '10rem',  // Adjust the width as needed
            },
        },
        {
            name: 'Max Budget',
            selector: row => row.MaxBudget,
            style: {
                width: '10rem',  // Set a smaller width for this column
            },
        },
        {
            name: 'Progress (%)',
            selector: row => row.progress + "%",
            style: {
                width: '10rem',  // Adjust the width for consistency
            },
        },
        {
            name: 'Remaining Budget',
            selector: row => (row.remainingBudget),
            style: {
                width: '10rem',
            },
        },
    ];

    useEffect(() => {
        dispatch(getUserInfo());
        dispatch(getMyBrandBusinessDetail((status, response, message) => {
            if (!userInfo?.phoneNumber || isAppleUser) {
                setIsPhoneVerifyPopupOpen(true)
            } else if (isPhoneVerifyPopupOpen) {
                const hasFirstName = userInfo?.firstName && userInfo?.firstName !== 'Apple';
                const hasLastName = userInfo?.lastName && userInfo?.lastName !== 'User';

                if (hasFirstName && hasLastName && userInfo?.country?.countryId) {
                    setIsPhoneVerifyPopupOpen(false);
                }
            } else if (status === 302) {
                setPopupOpen(true)
            }
        }))
    }, [isPhoneVerifyPopupOpen]);

    useEffect(() => {
        if (getUserInfoReducer.status === 200) {
            if (!userInfo?.phoneNumber || isAppleUser) {
                setIsPhoneVerifyPopupOpen(true)
            } else if (isPhoneVerifyPopupOpen) {
                const hasFirstName = userInfo?.firstName && userInfo?.firstName !== 'Apple';
                const hasLastName = userInfo?.lastName && userInfo?.lastName !== 'User';

                if (hasFirstName && hasLastName && userInfo?.country?.countryId) {
                    setIsPhoneVerifyPopupOpen(false);
                }
            }
        } else if (getUserInfoReducer.status === 403) {
            Toast(getUserInfoReducer.message, 'error');
            dispatch(getUserInfoReset());
        } else if (getUserInfoReducer.status) {
            Toast(getUserInfoReducer.message, 'info');
            dispatch(getUserInfoReset());
        }
    }, [getUserInfoReducer]);

    useEffect(() => {
        if (userInfo) {
            setFirstName(isAppleUser ? '' : userInfo.firstName || '');
            setLastName(isAppleUser ? '' : userInfo.lastName || '');
            setPhoneNumber(userInfo.phoneNumber || '');
            setGender(userInfo.gender || '');
            setReferredBy(userInfo.referredBy || '');
            if (userInfo.country && getAllCountryReducer?.data) {
                const country = getAllCountryReducer.data.find(c => c.countryId === userInfo.country.countryId);
                if (country) setCountryCode(country);
            }
        }
    }, [userInfo, getAllCountryReducer?.data]);

    const validateForm = (data) => {
        let formErrors = {};

        if (!data.firstName.trim()) {
            formErrors.firstName = 'First name is required';
        } else if (!/^[a-zA-Z\s]+$/.test(data.firstName)) {
            formErrors.firstName = 'First name should only contain alphabets';
        }
        if (!data.lastName.trim()) {
            formErrors.lastName = 'Last name is required';
        } else if (!/^[a-zA-Z\s]+$/.test(data.lastName)) {
            formErrors.lastName = 'Last name should only contain alphabets';
        }
        // gender is optional
        if (!data.countryId) {
            formErrors.countryId = 'Country is required';
        }

        // Validate Phone Number
        if (!data.phoneNumber.trim()) {
            formErrors.phoneNumber = 'Phone number is required';
        } else if (!/^\d{10}$/.test(data.phoneNumber)) {
            formErrors.phoneNumber = 'Enter a valid 10-digit phone number';
        }

        return formErrors;
    };

    const handleVerify = () => {
        if (otpMobile.join('').length !== 4) {
            setMessage('* Please enter valid OTP');
        } else {
            setMessage('');
            dispatch(verifyMobileOtp({
                sessionCode: utilReducers.sessionToken,
                phoneOtp: otpMobile.join(''),
                emailOtp: null,
                userType: userInfo.userType === "BRAND" ? "BRAND" : userInfo.userType === "AGENCY" ? "AGENCY" : ""
            }));
            // dispatch(verifyOtpForLogin({
            //     sessionCode: utilReducers.sessionToken,
            //     phoneOtp: otpMobile.join(''),
            //     emailOtp: otpEmail.join('')
            // }));
        }
    };

    const handleChange2 = (e, index) => {
        const { value } = e.target;
        if (/^[0-9]?$/.test(value)) { // Only allow numeric input
            const newOtp = [...otpMobile];
            newOtp[index] = value;
            setOtpMobile(newOtp);

            // Move to the next input if current one is filled
            if (value && index < 3) {
                document.getElementById(`mobile-input-${index + 1}`).focus();
            }
        }
    };

    const handleKeyDown2 = (e, index) => {
        // Move to the previous input if Backspace is pressed and input is empty
        if (e.key === 'Backspace' && !otpMobile[index] && index > 0) {
            document.getElementById(`mobile-input-${index - 1}`).focus();
        }
    };

    const handlePaste2 = (e) => {
        const paste = e.clipboardData.getData('text').slice(0, 4).split('');
        if (/^\d+$/.test(paste.join(''))) {
            setOtpMobile(paste);
            paste.forEach((value, index) => {
                if (index < 4) {
                    document.getElementById(`mobile-input-${index}`).value = value;
                }
            });
        }
    };

    const handleSendOtp = () => {
        const formData = {
            firstName: firstName,
            lastName: lastName,
            gender: gender,
            phoneNumber: phoneNumber,
            countryId: countryCode?.countryId
        };

        const formErrors = validateForm(formData);
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
        } else {
            setErrors({});
            dispatch(sendOtpForMobileVerified({
                "firstName": formData.firstName.trim(),
                "lastName": formData.lastName.trim(),
                "gender": formData.gender,
                "email": userInfo.email,
                "countryId": countryCode?.countryId || 1,
                "phoneNumber": formData.phoneNumber,
                "userType": userInfo.userType === "BRAND" ? "BRAND" : userInfo.userType === "AGENCY" ? "AGENCY" : "",
                "referredBy": referredBy.trim() || null
            }));
        }
    }

    const handleUpdateProfileOnly = () => {
        const formData = {
            firstName: firstName,
            lastName: lastName,
            gender: gender,
            phoneNumber: phoneNumber,
            countryId: countryCode?.countryId
        };

        const formErrors = validateForm(formData);
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
        } else {
            setErrors({});
            dispatch(updateUserInfo({
                "userId": userInfo.userId,
                "firstName": formData.firstName.trim(),
                "lastName": formData.lastName.trim(),
                "gender": formData.gender,
                "email": userInfo.email,
                "countryId": countryCode?.countryId || 1,
                "phoneNumber": formData.phoneNumber,
                "referredBy": referredBy.trim() || null
            }));
        }
    }

    const handleFilter = (brandId) => {
        setSelectedBrandId(brandId || "");
        setBrandId(brandId);
        dispatch(getDashboardData({ brandId: brandId ? brandId : "", platform: platformFilter === "ALL" ? "" : platformFilter }));
        if (selectedState) {
            dispatch(getCampaignListWithFilterDashBoard({
                "countryId": country ? country : 1,
                "stateId": selectedState ? selectedState : null,
                "brandId": brandId ? brandId : ""
            }));
        }
    };

    const handleReset = () => {
        setSelectedBrandId("");
        setBrandId("");
        dispatch(getDashboardData({ brandId: "", platform: platformFilter === "ALL" ? "" : platformFilter }));
        if (selectedState) {
            dispatch(getCampaignListWithFilterDashBoard({
                "countryId": country ? country : 1,
                "stateId": selectedState ? selectedState : null,
                "brandId": ""
            }));
        }
    };

    useEffect(() => {
        if (sendOtpForMobileVerifiedReducer.status === 200) {
            Toast(sendOtpForMobileVerifiedReducer.message, 'success');
            setOtpShow(true);
            dispatch(sendOtpForMobileVerifiedReset());
            // navigate('/verifyOtp');
        } else if (sendOtpForMobileVerifiedReducer.status === 403) {
            Toast(sendOtpForMobileVerifiedReducer.message, 'error');
            dispatch(sendOtpForMobileVerifiedReset());
        } else if (sendOtpForMobileVerifiedReducer.status === 302) {
            Toast(sendOtpForMobileVerifiedReducer.message, 'error');
            dispatch(sendOtpForMobileVerifiedReset());
        } else if (sendOtpForMobileVerifiedReducer.status) {
            Toast(sendOtpForMobileVerifiedReducer.message, 'info');
            dispatch(sendOtpForMobileVerifiedReset());
        }

        // Log the reducer state for debugging

    }, [sendOtpForMobileVerifiedReducer]);

    useEffect(() => {
        if (verifyMobileOtpReducer.status === 200) {
            Toast(verifyMobileOtpReducer.message, 'success')
            dispatch(getUserInfo());
            setOtpShow(false);
            dispatch(verifyMobileOtpReset())
        } else if (verifyMobileOtpReducer.status === 302) {
            Toast(verifyMobileOtpReducer.message, 'error')
            dispatch(verifyMobileOtpReset())
        } else if (verifyMobileOtpReducer.status === 303) {
            Toast(verifyMobileOtpReducer.message, 'error')
            dispatch(verifyMobileOtpReset())
        } else if (verifyMobileOtpReducer.status === 305) {
            Toast(verifyMobileOtpReducer.message, 'error')
            setMessage(verifyMobileOtpReducer?.message)
            dispatch(verifyMobileOtpReset())
        } else if (verifyMobileOtpReducer.status === 403) {
            Toast(verifyMobileOtpReducer.message, 'error')
            dispatch(verifyMobileOtpReset())
        } else if (verifyMobileOtpReducer.status) {
            Toast(verifyMobileOtpReducer.message, 'info')
            dispatch(verifyMobileOtpReset())
        }
    }, [verifyMobileOtpReducer]);

    useEffect(() => {
        if (updateUserInfoReducer.status === 200) {
            Toast(updateUserInfoReducer.message, 'success')
            dispatch(getUserInfo());
            dispatch(updateUserInfoReset());
        } else if (updateUserInfoReducer.status === 403) {
            Toast(updateUserInfoReducer.message, 'error')
            dispatch(updateUserInfoReset())
        } else if (updateUserInfoReducer.status) {
            Toast(updateUserInfoReducer.message, 'info')
            dispatch(updateUserInfoReset())
        }
    }, [updateUserInfoReducer]);

    useEffect(() => {
        // dispatch(getDashboardData({ brandId: brandId ? brandId : "", platform: platformFilter === "ALL" ? "" : platformFilter }));
        dispatch(getAllCountry());
    }, [])

    useEffect(() => {
        dispatch(getDashboardData({ brandId: brandId ? brandId : "", platform: platformFilter === "ALL" ? "" : platformFilter }));
    }, [platformFilter])

    useMemo(() => {
        if (getAllCountryReducerStatus == 200) {
            dispatch(getStateByCountry({ countryId: country ? country : 1 }));
        }
    }, [getAllCountryReducerStatus, country])

    return (
        <div className="w-full h-full bg-[#EDEEF1] overflow-scroll">
            <div className="w-full flex flex-col">
                {/* Header */}
                {/* Greeting Section */}
                <div className="flex justify-between items-center px-[4rem]">
                    <div className=" mt-[3rem]">
                        <h2 className="text-[2.8rem] text-black inter-font font-[500]">
                            Hii {getUserInfoReducerData?.firstName ? getUserInfoReducerData?.firstName : "User"}!
                        </h2>
                        <h2 className="text-[1.8rem] text-black inter-font font-[500] mt-2">
                            Welcome to creator dashboard lets collaborate!
                        </h2>
                    </div>
                    {/* <select
                        className="border-2 border-gray-300 w-[20rem] p-3 pr-14 rounded-md text-[1.4rem] inter-font font-[400] outline-none bg-white"
                        value={platformFilter}
                        onChange={(e) => setPlatformFilter(e.target.value)}
                    >
                        <option value="ALL">All</option>
                        <option value="YOUTUBE">YouTube</option>
                        <option value="INSTAGRAM">Instagram</option>
                    </select> */}
                </div>
                {/* Dashboard Content */}
                {userInfo?.userType === "AGENCY" &&
                    <div className="px-[4rem] mt-[3rem]">
                        <BrandFilterBar onFilter={handleFilter} onReset={handleReset} />
                    </div>
                }
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 px-[4rem] mt-[3rem]">
                    {/* Card 1: Views of Campaign By State */}
                    <div className="bg-white p-6 shadow-md rounded-lg h-[38rem]">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-[2.4rem] inter-font font-[400]">Views of Campaign By State</h3>
                            <div className='w-[7.4rem] h-[7.4rem]'>
                                <img src={InfluencerImg.barnd1} alt="Icon" className='w-full h-full' />
                            </div>
                        </div>
                        <div className="flex flex-col justify-between items-center gap-4">
                            <div className="grid grid-cols-2 gap-4 w-full">
                                <select
                                    className="w-full px-4 py-4 inter-font font-[400] text-[1.6rem] text-black border border-gray-300 rounded-lg focus:outline-none"
                                    value={country}
                                    onChange={(e) => setCountry(e.target.value)}
                                >
                                    {getAllCountryReducerData?.map((country) => {
                                        return (
                                            <option value={country.countryId}>{country.countryName}</option>
                                        )
                                    })
                                    }
                                </select>
                                <select
                                    id="state"
                                    value={selectedState}
                                    onChange={(e) => {
                                        setSelectedState(e.target.value);
                                        dispatch(getCampaignListWithFilterDashBoard({
                                            "countryId": country ? country : 1,
                                            "stateId": e.target.value ? e.target.value : null,
                                            "brandId": selectedBrandId ? selectedBrandId : ""
                                        }))
                                    }}
                                    className="w-full px-4 py-4 inter-font font-[400] text-[1.6rem] text-black border border-gray-300 rounded-lg focus:outline-none" required>
                                    <option value="" selected>Select State</option>
                                    {Array.isArray(getStateByCountryReducerData) && getStateByCountryReducerData.map((items) => (
                                        <option key={items.stateId} value={items.stateId}>
                                            {items.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="mt-4 max-h-[200px] overflow-y-auto w-full">
                                <table className="w-full text-left border-collapse">
                                    <thead className='bg-[#F1F4F9] border'>
                                        <tr className="">
                                            <th className="text-[1.4rem] text-black inter-font font-[500] p-2 w-[40%] text-center">Campaign</th>
                                            <th className="text-[1.4rem] text-black inter-font font-[500] p-2 w-[40%] text-center">Period</th>
                                            <th className="text-[1.4rem] text-black inter-font font-[500] p-2 w-[20%] text-center">Views</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {getCampaignListWithFilterDashBoardReducerData?.length > 0 ? (
                                            getCampaignListWithFilterDashBoardReducerData.map((item) => (
                                                <tr key={item.id} className="border border-gray-200">
                                                    <td
                                                        className="text-[1.4rem] text-black inter-font font-[400] p-2 truncate text-center"
                                                        title={item.campaignName}
                                                        style={{
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            maxWidth: '150px', // Adjust based on available width
                                                        }}
                                                    >
                                                        {item.campaignName}
                                                    </td>
                                                    <td className="text-[1.4rem] text-black inter-font font-[400] p-2">
                                                        {item.startDate + " to " + item.endDate}
                                                    </td>
                                                    <td className="text-[1.4rem] text-black inter-font font-[400] p-2 text-center">
                                                        {item.views ? item.views : 0}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr className='h-[15rem]'>
                                                <td
                                                    className="text-[1.4rem] text-black inter-font font-[400] align-middle p-2 text-center py-2"
                                                    colSpan={3}
                                                >
                                                    No Data Available!
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    {/* Card 2: Campaign Status */}
                    <div className="bg-white p-6 shadow-md rounded-lg h-[38rem]">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-[2.4rem] inter-font font-[400]">Campaign Status</h3>
                            <div className='w-[7.4rem] h-[7.4rem]'>
                                <img src={InfluencerImg.barnd2} alt="Icon" className='w-full h-full' />
                            </div>
                        </div>
                        <div className="max-h-[200px] overflow-y-auto">
                            <table className="w-full text-left border">
                                <thead>
                                    <tr className="bg-[#F1F4F9]">
                                        <th className="text-[1.4rem] text-black inter-font font-[500] p-2 w-[60%] text-center">Status</th>
                                        <th className="text-[1.4rem] text-black inter-font font-[500] p-2 w-[40%] text-center">No of Campaign</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {getDashboardDataReducerData?.campaignStatusCountJson?.length > 0 ? (
                                        getDashboardDataReducerData?.campaignStatusCountJson?.map((data, index) => (
                                            <tr key={index} className="border border-gray-200">
                                                <td
                                                    className="text-[1.4rem] text-black inter-font font-[400] p-2 truncate text-center"
                                                    title={data.status}
                                                    style={{
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        maxWidth: '200px', // Adjust width as necessary
                                                    }}
                                                >
                                                    {data.status}
                                                </td>
                                                <td className="text-[1.4rem] text-black inter-font font-[400] p-2 text-center">
                                                    {data.statusCount}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td className="text-[1.4rem] text-black inter-font font-[400]  p-2 py-5 text-center" colSpan={2}>
                                                No Data Available!
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {/* Card 3: Influencer/Campaign */}
                    <div className="bg-white shadow-md rounded-lg flex flex-col h-[38rem]">
                        <div className="h-[19rem] p-6">
                            <div className="flex justify-between items-center mb-4">
                                <h3 className="text-[2.4rem] inter-font font-[400]">Influencer/Campaign</h3>
                                <div className='w-[7.4rem] h-[7.4rem]'>
                                    <img src={InfluencerImg.barnd3} alt="Icon" className='w-full h-full' />
                                </div>
                            </div>
                            <p className="text-[2rem] font-bold">
                                {getDashboardDataReducerData?.influencerCampaignCount?.influencer ? getDashboardDataReducerData?.influencerCampaignCount?.influencer : 0}/{getDashboardDataReducerData?.influencerCampaignCount?.campaign ? getDashboardDataReducerData?.influencerCampaignCount?.campaign : 0}
                            </p>
                        </div>
                        <div className="h-[19rem] p-6 border-t">
                            <div className="flex justify-between items-center mb-4">
                                <h3 className="text-[2.4rem] inter-font font-[400]">Total Views of 10 brands</h3>
                                <div className='w-[7.4rem] h-[7.4rem]'>
                                    <img src={InfluencerImg.barnd4} alt="Icon" className='w-full h-full' />
                                </div>
                            </div>
                            <p className="text-[2rem] font-bold">{getDashboardDataReducerData?.viewTopTenBrand ? getDashboardDataReducerData?.viewTopTenBrand : 0}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mb-8 px-[4rem] mt-[3rem]">
                <h3 className="text-[2.8rem] inter-font text-black mb-4">Recent Campaign</h3>
                <div className="w-full !overflow-y-scroll no-scrollbar relative">
                    {Array.isArray(getDashboardDataReducerData?.influencerViewsProgress?.data) && getDashboardDataReducerData?.influencerViewsProgress?.data.length > 0 ? (
                        <DataTable
                            columns={columns}
                            data={getDashboardDataReducerData?.influencerViewsProgress?.data}
                            customStyles={customTableStyles}
                            highlightOnHover
                            responsive
                        />
                    ) : null}
                </div>
                <div className="w-full !overflow-y-scroll no-scrollbar relative">
                    {Array.isArray(getDashboardDataReducerData?.influencerEarningProgress?.data) && getDashboardDataReducerData?.influencerEarningProgress?.data.length > 0 ? (
                        <DataTable
                            columns={columnsMaxBudget}
                            data={getDashboardDataReducerData?.influencerEarningProgress?.data}
                            customStyles={customTableStyles}
                            highlightOnHover
                            responsive
                        />
                    ) : (
                        <div className="text-4xl leading-[70px] text-gray-500 text-center mt-4">
                            There are no records to display.
                        </div>
                    )}
                </div>
            </div>
            <Popup
                isOpen={isPhoneVerifyPopupOpen}
                title="Complete Profile"
                canDismiss={false}
                isOverflowVisible={true}
                content={
                    <div className="w-[85%] mx-auto !overflow-visible flex flex-col gap-4 mt-4">
                        {(!userInfo?.firstName || isAppleUser) && (
                            <div className="w-full">
                                <label className="text-[1.6rem] text-[#111729] roboto-thin font-[400]">First Name</label>
                                <input
                                    type="text"
                                    placeholder="First Name"
                                    value={firstName}
                                    disabled={otpShow}
                                    onChange={(e) => setFirstName(e.target.value)}
                                    className={`w-full px-[1.6rem] py-[.8rem] bg-[#F3F9FA] border rounded-[1.2rem] focus:outline-none text-[1.6rem] ${errors.firstName ? 'border-red-500' : 'border-gray-300'}`}
                                />
                                {errors.firstName && <p className="text-red-500 text-[1.2rem]">{errors.firstName}</p>}
                            </div>
                        )}

                        {(!userInfo?.lastName || isAppleUser) && (
                            <div className="w-full">
                                <label className="text-[1.6rem] text-[#111729] roboto-thin font-[400]">Last Name</label>
                                <input
                                    type="text"
                                    placeholder="Last Name"
                                    value={lastName}
                                    disabled={otpShow}
                                    onChange={(e) => setLastName(e.target.value)}
                                    className={`w-full px-[1.6rem] py-[.8rem] bg-[#F3F9FA] border rounded-[1.2rem] focus:outline-none text-[1.6rem] ${errors.lastName ? 'border-red-500' : 'border-gray-300'}`}
                                />
                                {errors.lastName && <p className="text-red-500 text-[1.2rem]">{errors.lastName}</p>}
                            </div>
                        )}

                        {!userInfo?.gender && (
                            <div className="w-full">
                                <label className="text-[1.6rem] text-[#111729] roboto-thin font-[400]">Gender</label>
                                <select
                                    value={gender}
                                    disabled={otpShow}
                                    onChange={(e) => setGender(e.target.value)}
                                    className={`w-full px-[1.6rem] py-[.8rem] bg-[#F3F9FA] border rounded-[1.2rem] focus:outline-none text-[1.6rem] ${errors.gender ? 'border-red-500' : 'border-gray-300'}`}
                                >
                                    <option value="">Select Gender</option>
                                    <option value="MALE">Male</option>
                                    <option value="FEMALE">Female</option>
                                    <option value="OTHER">Other</option>
                                </select>
                                {errors.gender && <p className="text-red-500 text-[1.2rem]">{errors.gender}</p>}
                            </div>
                        )}

                        {!userInfo?.phoneNumber && (
                            <div className="w-full !overflow-visible">
                                <label className="text-[1.6rem] text-[#111729] roboto-thin font-[400]">Mobile Number</label>
                                <div className={`flex items-center w-full px-[1.6rem] py-[.8rem] bg-[#F3F9FA] border rounded-[1.2rem] focus:outline-none !overflow-visible ${errors.phoneNumber ? 'border-red-500' : 'border-gray-300'}`}>
                                    <DropdownWithSearch
                                        options={getAllCountryReducer?.data}
                                        onChange={setCountryCode}
                                        value={countryCode}
                                        disabled={otpShow}
                                    />
                                    <input
                                        type="number"
                                        placeholder="Phone Number"
                                        maxLength={10}
                                        value={phoneNumber}
                                        disabled={otpShow}
                                        onChange={(e) => {
                                            const input = e.target.value;
                                            if (input.length <= 10) {
                                                setPhoneNumber(input);
                                            }
                                        }}
                                        className="bg-[#F3F9FA] text-[1.6rem] border-none focus:ring-0 outline-none w-full ml-2"
                                    />
                                </div>
                                {errors.phoneNumber && <p className="text-red-500 text-[1.2rem] mt-1">{errors.phoneNumber}</p>}
                            </div>
                        )}

                        {!userInfo?.referredBy && (
                            <div className="w-full">
                                <label className="text-[1.6rem] text-[#111729] roboto-thin font-[400]">Referred By (Optional)</label>
                                <input
                                    type="text"
                                    placeholder="Enter referrer's name (if any)"
                                    value={referredBy}
                                    disabled={otpShow}
                                    onChange={(e) => setReferredBy(e.target.value)}
                                    className="w-full px-[1.6rem] py-[.8rem] bg-[#F3F9FA] border border-gray-300 rounded-[1.2rem] focus:outline-none text-[1.6rem]"
                                />
                            </div>
                        )}

                        {otpShow &&
                            <div className="mb-4">
                                <h2 className="text-[1.6rem] text-[#111729] roboto-thin font-[400] mb-2">Mobile OTP</h2>
                                <div className="flex justify-between items-center w-[75%]" onPaste={handlePaste2}>
                                    {otpMobile.map((value, index) => (
                                        <input
                                            key={index}
                                            id={`mobile-input-${index}`}
                                            type="text"
                                            maxLength="1"
                                            value={value}
                                            onChange={(e) => handleChange2(e, index)}
                                            onKeyDown={(e) => handleKeyDown2(e, index)}
                                            className={`w-[4.5rem] h-[4.5rem] border rounded-[.8rem] text-center text-[1.8rem] ${(message && !verifyMobileOtpReducer?.status) ? 'border-red-500' : 'border-gray-300'}`}
                                        />
                                    ))}
                                </div>
                                {message && <p className="text-red-500 text-[1.4rem] mt-2">{message}</p>}
                            </div>
                        }
                    </div>
                }
                primaryButtonWidth='w-[30rem]'
                size="mdsm"
                primaryButton={{
                    text: otpShow ? 'Verify' : (userInfo?.phoneNumber ? 'Submit' : 'Send OTP'),
                    onClick: () => {
                        if (otpShow) {
                            handleVerify();
                        } else if (userInfo?.phoneNumber) {
                            handleUpdateProfileOnly();
                        } else {
                            handleSendOtp();
                        }
                    },
                }}
            />
            <Popup
                isOpen={isPopupOpen}
                onClose={() => setPopupOpen(false)}
                title="Business Registration"
                canDismiss
                icon={<SiLibreofficewriter color="#D72828" size={110} className="my-[5rem] size-[80px] lg:size-[100px]" />}
                content={<p className='text-[1.6rem] w-[80%] mx-auto text-center'>Please register your business to access the campaign creation features</p>}
                size="sm"
                primaryButton={{
                    text: 'Add Business',
                    onClick: () => {
                        navigate("/brand/busisness")
                        setPopupOpen(false);
                    },
                }}
                secondaryButton={{
                    text: 'Not Now',
                    onClick: () => setPopupOpen(false),
                }}
            />
            <Footer />
        </div>
    );
};

export default BrandDashboardV2;
